module.exports = __webpack_public_path__ + "img/image_of_content_load.f2989b58.gif";